import { Navigate } from "react-router-dom";

const ErrorElement = () => {
  return <Navigate to={"/"} replace={true} />;
};

export default ErrorElement;
